export default __webpack_public_path__ + "static/media/detail_2.cf446c24.jpg";